import { forwardRef, useState } from 'react'

const Textarea = forwardRef(function Textarea(
  { error = false, rows = 4, style: styleOverride, onFocus, onBlur, disabled = false, ...rest },
  ref
) {
  const [focused, setFocused] = useState(false)
  const borderColor = error
    ? 'var(--olv-red)'
    : focused
      ? 'var(--olv-purple)'
      : 'rgba(255,255,255,0.08)'

  return (
    <textarea
      ref={ref}
      rows={rows}
      disabled={disabled}
      onFocus={(e) => { setFocused(true); onFocus?.(e) }}
      onBlur={(e) => { setFocused(false); onBlur?.(e) }}
      style={{
        width: '100%',
        padding: '10px 14px',
        background: disabled ? 'rgba(255,255,255,0.02)' : 'rgba(12,12,20,0.6)',
        border: `1px solid ${borderColor}`,
        borderRadius: 'var(--olv-radius-card)',
        color: disabled ? 'var(--olv-text-tertiary)' : 'var(--olv-text-primary)',
        fontSize: 13,
        fontFamily: 'var(--font-body)',
        lineHeight: 1.5,
        outline: 'none',
        resize: 'vertical',
        transition: 'border-color 200ms var(--ease-standard)',
        backdropFilter: 'blur(8px)',
        cursor: disabled ? 'not-allowed' : 'text',
        ...styleOverride,
      }}
      {...rest}
    />
  )
})

export default Textarea
